<template>
  <v-card v-if="isAdmin" tile>
    <v-card-title>
      <span class="text-h5">Export</span>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-row>
          <v-col cols="12">
            <v-btn color="success" dark large>
              <a class="white--text link" href="/export-students">Export students</a>
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-btn color="warning" dark large>
              <a class="white--text link" href="/export-student-courses">Export courses</a>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex"

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters("Auth", ["isAdmin"]),
  },
}
</script>
